import { AppActionTypes, GetProductsSuccessPayload } from 'store/app/actions/types'

export const GET_PRODUCTS = 'APP/GET_PRICELISTS'
export const GET_PRODUCTS_SUCCESS = 'APP/GET_PRICELISTS_SUCCESS'
export const GET_PRODUCTS_ERROR = 'APP/GET_PRICELISTS_ERROR'

export const getProducts = (): AppActionTypes => {
  return { type: GET_PRODUCTS }
}

export const getProductsSuccess = ({ products }: GetProductsSuccessPayload): AppActionTypes => {
  return { type: GET_PRODUCTS_SUCCESS, products }
}

export const getProductsError = (): AppActionTypes => {
  return { type: GET_PRODUCTS_ERROR }
}
